import { ShadowBox } from 'components/ShadowBox'
import React, { PropsWithChildren } from 'react'
import { isMobile } from 'react-device-detect'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { Me, Usage } from 'service/user'
import { FormValues } from 'utils/type'
import { TextArea } from './TextArea'
import { Input } from 'components/atom/Input'
import { PRODUCT_NAME_PATTERN } from '../util'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { UserType } from 'utils/common'

interface ErrorType {
  products: {
    link: boolean
    product: boolean
  }[]
  mainTitle: boolean
  thumbnail: boolean
}
interface YoutubeTitleProps {
  watch: UseFormWatch<FormValues>
  control: Control<FormValues, any>
  setValue: UseFormSetValue<FormValues>
  userInfo: Me
  clipTitleIsPending: boolean
  thumbnailIsPending: boolean
  aiRecommendClipTitle: string[] | null
  mainTitleInputRef: React.MutableRefObject<HTMLInputElement | null>
  setError: React.Dispatch<React.SetStateAction<ErrorType>>
  error: ErrorType
  usage: Usage | undefined
}

export const YoutubeTitle = ({
  watch,
  control,
  setValue,
  userInfo,
  clipTitleIsPending,
  thumbnailIsPending,
  aiRecommendClipTitle,
  mainTitleInputRef,
  setError,
  error,
  usage,
}: PropsWithChildren<YoutubeTitleProps>) => {
  return (
    <ShadowBox className="py-[40px]  md:w-[816px] relative">
      {watch('products.0.link') === '' && (
        <div className="py-[40px] px-[16px] md:w-[816px] w-full h-full bg-white absolute z-50 left-0 opacity-50"></div>
      )}
      <div className="flex flex-col gap-[16px]  w-full ">
        <div className="flex flex-col items-center ">
          <h3 className="font-bold text-[#2E343D] text-[24px] ">
            유튜브 영상용 제목 입력
          </h3>
          <p className="text-main text-[14px]">매력적인 내용을 정해주세요!</p>
        </div>
        <div className="md:px-0 px-4">
          <span className="font-bold text-white bg-[#2E343D] flex  items-center w-[65px] h-[22px] rounded-[4px] text-[12px] justify-center mb-2">
            <StarIcon className="text-white" /> AI 추천
          </span>
          {clipTitleIsPending || thumbnailIsPending ? (
            <>
              <div className="flex flex-col gap-1">
                {new Array(5).fill(0).map((el, index) => (
                  <div className="w-full h-[20px] relative " key={index}>
                    <div className="absolute inset-0 bg-gray-300 overflow-hidden">
                      <div className="h-full w-full bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 animate-skeleton"></div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              {' '}
              {aiRecommendClipTitle?.map((el) => (
                <>
                  <button
                    className="bg-[#EEF1F7] px-2 py-1 rounded-[6px] flex hover:bg-[#BBEBEC] mt-1 text-left"
                    type="button"
                    onClick={() => {
                      setValue('mainTitle', el)
                    }}
                  >
                    {el}
                  </button>
                </>
              ))}
            </>
          )}
        </div>
        <div className="flex flex-col items-center w-full md:w-[736px] gap-[8px]">
          <div className="relative">
            <Controller
              key="mainTitle"
              render={({ field }) => (
                <>
                  {isMobile ? (
                    <>
                      {' '}
                      <TextArea
                        inputRef={mainTitleInputRef}
                        error={error.mainTitle}
                        disabled={
                          usage &&
                          !usage?.available &&
                          userInfo?.userType !== UserType.체험
                        }
                        {...field}
                        placeholder="유튜브 영상용 제목 입력 (90자 이하)"
                        maxLength={90}
                      />
                    </>
                  ) : (
                    <Input
                      inputRef={mainTitleInputRef}
                      error={error.mainTitle}
                      disabled={
                        usage &&
                        !usage?.available &&
                        userInfo?.userType !== UserType.체험
                      }
                      {...field}
                      placeholder="유튜브 영상용 제목 입력 (90자 이하)"
                      maxLength={90}
                    />
                  )}
                  <div
                    className={`flex gap-[4px] mt-[8px] ${
                      (field.value.length > 90 ||
                        !PRODUCT_NAME_PATTERN.test(field.value)) &&
                      'text-error'
                    }`}
                  >
                    <span>{field.value.length}/90</span>
                    <span>{`이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.`}</span>
                  </div>
                </>
              )}
              name={'mainTitle'}
              rules={{
                required: {
                  value: true,
                  message: '유튜브 영상 제목은 필수입니다!',
                },
                maxLength: {
                  value: 90,
                  message: '유튜브 영상 제목의 길이가 90자를 넘습니다.',
                },
                validate: (value) => {
                  const updateError = { ...error }
                  updateError.mainTitle = false
                  setError(updateError)
                  return (
                    PRODUCT_NAME_PATTERN.test(value) ||
                    '이모지와 꺽쇠괄호(< >)는 허용되지 않습니다.'
                  )
                },
              }}
              control={control}
            />
          </div>
        </div>
      </div>
    </ShadowBox>
  )
}
